import api from '../config/api';

export const paymentService = {
  initiatePayment: (orderId, paymentMethod = 'razorpay') =>
    api.post('/payments/initiate', { order_id: orderId, payment_method: paymentMethod }),

  verifyRazorpay: (verifyData) =>
    api.post('/payments/razorpay/verify', verifyData),

  // Admin: process full or partial refund (Razorpay Route-aware)
  processRefund: ({ order_id, amount, reason }) =>
    api.post('/split-payments/refund', { order_id, amount, reason }),

  // Admin: get all Route transfers for an order
  getOrderTransfers: (orderId) =>
    api.get(`/split-payments/transfers/${orderId}`),

  // Admin: retry all failed Route transfers
  retryFailedTransfers: () =>
    api.post('/split-payments/retry-transfers'),
};
